import { render } from "./ContentView.vue?vue&type=template&id=8289ef70&scoped=true&ts=true"
import script from "./ContentView.vue?vue&type=script&lang=ts"
export * from "./ContentView.vue?vue&type=script&lang=ts"

import "./ContentView.vue?vue&type=style&index=0&id=8289ef70&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8289ef70"]])

export default __exports__